import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CreateOption } from '../new-vessel-dialog.component';

@Component({
    selector: 'app-new-vessel-option',
    templateUrl: './new-vessel-option.component.html',
    styleUrl: './new-vessel-option.component.css',
    standalone: false,
})
export class NewVesselOptionComponent implements OnInit {
    @Input() option: CreateOption;
    @Output() onOptionSelected: EventEmitter<CreateOption> = new EventEmitter();

    icon: string;
    title: string;
    description: string;
    button: string;

    ngOnInit(): void {
        if (this.option == CreateOption.BEGINNGING) {
            this.icon = 'pan';
            this.title = 'vessel.create.option.beginning.title';
            this.description = 'vessel.create.option.beginning.description';
            this.button = 'vessel.create.option.beginning.button';
        } else if (this.option == CreateOption.REPURPOSE) {
            this.icon = 'vessel-folder';
            this.title = 'vessel.create.option.repurpose.title';
            this.description = 'vessel.create.option.repurpose.description';
            this.button = 'vessel.create.option.repurpose.button';
        }
    }

    optionSelected() {
        this.onOptionSelected.emit(this.option);
    }
}
